import { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Form, Row, Col } from 'react-bootstrap';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { deleteUser, getUser, getUserGroups } from 'api/api';

const breadcrumbItems = [
  {
    label: 'Users',
    url: '/users/users'
  },
  {
    label: 'Delete',
    active: true
  }
];

const DeleteUser = () => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [userGroups, setUserGroup] = useState([]);
  const [userGroupId, setUserGroupId] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    loadData(id);
  }, [id]);

  useEffect(() => {
    loadUserGroups();
  }, []);

  const loadUserGroups = () => {
    setError([]);
    setLoading(true);

    getUserGroups()
      .then(response => {
        setUserGroup(response.data.data);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadData = id => {
    setError([]);
    setLoading(true);

    getUser(id)
      .then(response => {
        console.log(response);
        setName(response.data.data.name);
        setEmail(response.data.data.email);
        setUserGroupId({
          value: response.data.data.user_group.id,
          label: response.data.data.user_group.name
        });
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = e => {
    e.preventDefault();

    setError([]);
    setLoading(true);

    deleteUser(id)
      .then(response => {
        if (response.status === 200) navigate('/users/users');
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">Delete User</h2>
            <h5 className="text-700 fw-semi-bold">Delete a user</h5>
          </div>
        </div>
        <div>
          {Object.entries(error).length > 0 &&
            error.map((e, index) => (
              <Alert variant="soft-danger" key={index}>
                {e}
              </Alert>
            ))}
        </div>

        {loading && <LoadingOverlay />}

        <div>
          <Row className="justify-content-left">
            <Col md={8}>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Name*</Form.Label>
                      <Form.Control
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        readOnly
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        readOnly
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>User Group*</Form.Label>
                      <Select
                        classNamePrefix="react-select"
                        className="mb-2"
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        value={userGroupId}
                        options={
                          userGroups &&
                          userGroups.map(c => ({
                            value: c.id,
                            label: c.name
                          }))
                        }
                        onChange={e => setUserGroupId(e.value)}
                        isDisabled={true}
                        name="user_group"
                        menuPlacement="auto"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={2} className="d-flex align-items-end">
                    <Button variant="primary" type="submit" className="w-100">
                      Submit
                    </Button>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      className="w-100"
                      variant="phoenix-secondary"
                      type="button"
                      onClick={() => navigate('/users/users')}
                    >
                      Discard
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DeleteUser;
